import React from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {isPreviewing, isEditing} from '@builder.io/sdk-react'
import {PreviewContainer} from './previewContainer'
import {
    commonRoleBasedContentInputs,
    commonRoleBasedContentPropTypes,
    getDefaultChildren
} from './utils'

const accessType = 'Auth'

export const AuthContent = ({children, hideInEdit}) => {
    const {data: customer, isError: isCustomerError, error: customerError} = useCurrentCustomer()

    const isPreview = isPreviewing()
    const isEdit = isEditing()
    const isAuthenticatedUser = !customer.isGuest && customer.isRegistered

    if (isCustomerError && isPreview) {
        throw new Error('There was an issue fetching customer data: ', customerError)
    }

    if (isCustomerError) {
        console.error('There was an issue fetching customer data: ', customerError)
        return null
    }

    const renderAuthOnlyContent = () => {
        if ((!isAuthenticatedUser && !isEdit) || (isEdit && hideInEdit)) {
            return null
        }
        if (isEdit) {
            return (
                <PreviewContainer type={accessType} data-testid="authContent-PreviewContainer">
                    {children}
                </PreviewContainer>
            )
        }
        return children
    }

    return renderAuthOnlyContent()
}
AuthContent.propTypes = {
    ...commonRoleBasedContentPropTypes
}
export const AuthContentDefinition = {
    component: AuthContent,
    name: 'AuthContent',
    canHaveChildren: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/lock.svg',
    noWrap: true,
    defaultChildren: getDefaultChildren(accessType),
    inputs: [...commonRoleBasedContentInputs]
}
